import { Component, computed, inject, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { SvgIconComponent } from 'src/app/shared/components/svg-icon/svg-icon.component';
import { KeyUsages } from 'src/app/shared/entities/key-usages';
import { Profile } from 'src/app/shared/entities/profile';
import { LangService } from 'src/app/shared/services/lang/lang.service';

@Component({
  selector: 'app-profile-details',
  imports: [SvgIconComponent, MatButtonModule],
  templateUrl: './profile-details.component.html',
  styleUrl: './profile-details.component.scss',
})
export class ProfileDetailsComponent {
  private langService = inject(LangService);
  labels = this.langService.lang.features.profiles;
  profileKeys = this.labels.profileKeys;
  extendedKeyUsages = this.langService.lang.shared.extendedKeyUsages;
  keyUsages = this.langService.lang.shared.keyUsages;

  private keyUsagesArr = [
    KeyUsages.DIGITAL_SIGNATURE,
    KeyUsages.NON_REPUDIATION,
    KeyUsages.KEY_ENCIPHERMENT,
    KeyUsages.DATA_ENCIPHERMENT,
    KeyUsages.KEY_AGREEMENT,
    KeyUsages.KEY_CERT_SIGN,
    KeyUsages.CRL_SIGN,
    KeyUsages.ENCIPHER_ONLY,
    KeyUsages.DECIPHER_ONLY,
  ];

  value = input<Profile>();

  keyUsagesStatus = computed(() => this.keyUsagesToDisplayValues(this.value()));
  back = output();

  title = computed(() => this.labels.title(this.value()?.profileName ?? ''));

  onBack() {
    this.back.emit();
  }

  private keyUsagesToDisplayValues(
    profile: Profile | undefined,
  ): { displayName: string; isPresent: boolean }[] {
    if (profile === undefined) {
      return [];
    }
    return this.keyUsagesArr.map(keyUsage => ({
      displayName: this.keyUsages[keyUsage],
      isPresent: !!profile.keyUsages?.includes(keyUsage),
    }));
  }
}
